<template>
  <div>
    <ModalChangePassword></ModalChangePassword>
    <nav
      class="
        navbar navbar-expand-lg navbar-transparent
        bg-primary
        navbar-absolute
      "
    >
      <div class="container-fluid">
        <div class="navbar-wrapper">
          <div class="navbar-toggle">
            <button type="button" class="navbar-toggler">
              <span class="navbar-toggler-bar bar1"></span>
              <span class="navbar-toggler-bar bar2"></span>
              <span class="navbar-toggler-bar bar3"></span>
            </button>
          </div>
          <button
            id="shrinkSide"
            class="btn btn-sm btn-circle btn-transparent mr-2"
          >
            <i class="fas fa-bars"></i>
          </button>
          <button
            id="expandSide"
            class="btn btn-sm btn-circle btn-transparent mr-2"
            hidden
          >
            <i class="fas fa-bars"></i>
          </button>
          <p class="navbar-brand">
            <!-- {{ $route.meta.title }} {{ $route.params.id }} -->
            {{ $route.meta.title }}
          </p>
        </div>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navigation"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
        </button>
        <div
          class="collapse navbar-collapse justify-content-end"
          id="navigation"
        >
          <ul class="navbar-nav">
            <li class="nav-item">
              <div class="dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  role="button"
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  href="#"
                  @click="updateTab('informasi', 0)"
                >
                  <span
                    class="badge badge-warning"
                    style="
                      padding: 2px 3px 2px 2px;
                      margin-top: -2px;
                      position: absolute;
                      z-index: 2;
                      margin-right: -13px;
                      font-size: 10px;
                    "
                    >{{ this.user.totalNotifReminder }}</span
                  >
                  <i class="now-ui-icons ui-1_bell-53"></i>
                  <p>Pemberitahuan</p>
                </a>

                <div
                  class="dropdown-menu"
                  style="min-width: 20rem"
                  aria-labelledby="dropdownMenuLink"
                >
                  <div
                    class="triggerMiddleware card-header border-bottom"
                    style="margin-top: -9px; background-color: transparent;"
                  >
                    <div
                      class="triggerMiddleware row text-center px-3 py-2 border-bottom"
                      @click.stop
                    >
                      <div
                        class="triggerMiddleware col-md-6 badge"
                        :class="[
                          activeTab === 'informasi' ? 'badge-soft-primary' : '',
                        ]"
                        style="cursor: pointer;"
                        @click="updateTab('informasi', 0)"
                      >
                        <p
                          class="triggerMiddleware ml-2"
                          style="font-weight: 501; font-size: 9.5px;"
                        >
                          Informasi Untuk Anda
                        </p>
                      </div>
                      <div
                        class="triggerMiddleware col-md-6 badge"
                        :class="[
                          activeTab === 'followUp' ? 'badge-soft-primary' : '',
                        ]"
                        style="cursor: pointer;"
                        @click="updateTab('followUp', 1)"
                      >
                        <p
                          class="triggerMiddleware ml-2"
                          style="font-weight: 501; font-size: 10px;"
                        >
                          Perlu Di Tindaklanjuti
                        </p>
                      </div>
                    </div>
                    <div
                      class="text-center pt-1"
                      v-if="activeTab === 'informasi'"
                    >
                      <a
                        href="#"
                        class="triggerMiddleware badge badge-soft-warning p-2 mt-1 text-primary"
                        style="font-size: 11px;"
                      >
                        Mark all notif as read</a
                      >
                    </div>
                  </div>
                  <div
                    class="text-left"
                    style="
                      max-height: 350px;
                      overflow-y: auto;
                      overflow-x: hidden; 
                      scrollbar-width: thin;

                    "
                  >
                    <div class="text-center">
                      <!-- <img src="@/assets/upload/notif_mailbox.png" class="img-fluid mb-4" style="opacity: 0.3" width="80px" alt=""> -->
                    </div>
                    <div v-if="isLoading" class="dropdown-item float-left">
                      <content-placeholders :animated="false">
                        <content-placeholders-text :lines="8" />
                      </content-placeholders>
                    </div>
                    <div v-else>
                      <router-link
                        v-for="(ntf, index) in notifications"
                        :to="
                          ntf.type === 'order' ||
                          ntf.type === 'tagihan' ||
                          ntf.type === 'komplain' ||
                          ntf.type === 'pembayaran'
                            ? '/pesanan/detail/' + ntf.linkRedirect
                            : ntf.type === 'nego'
                            ? '/negoisasi/detail/' + ntf.linkRedirect
                            : '#'
                        "
                        :key="index"
                        class="dropdown-item float-left"
                        :style="{
                          backgroundColor:
                            ntf.isRead === false ? 'rgb(236, 244, 249)' : '',
                        }"
                      >
                        <button
                          class="btn btn-transparent btn-sm btn-circle text-truncate"
                          style="padding: 2px 0px"
                        >
                          <img :src="ntf.icon" class="img-fluid" alt="" />
                        </button>
                        <p class="text-truncate">
                          {{
                            ntf.title === "Pesanan baru telah dibuat"
                              ? "Anda mempunyai pesanan baru"
                              : ntf.title.length > 30
                              ? ntf.title.substring(0, 30) + "..."
                              : ntf.title
                          }}
                        </p>
                        <br />
                        <p
                          v-html="truncateText(ntf.text)"
                          style="font-size: 11px;"
                        ></p>
                      </router-link>
                      <!-- <p >No New Notifications</p>
                    <p class="text-muted"  style="font-size: 12px">
                        You have currently no notifications, We'll notify you when something new arrives!
                    </p> -->
                    </div>
                    <div
                      class="p-3 text-center"
                      v-if="notif.items && notif.items.length === 0"
                    >
                      <div class="text-center">
                        <img
                          src="@/assets/upload/notif_mailbox.png"
                          class="img-fluid mb-4"
                          style="opacity: 0.3"
                          width="80px"
                          alt=""
                        />
                      </div>
                      <p>No New Notifications</p>
                      <p class="text-muted" style="font-size: 12px">
                        You have currently no notifications, We'll notify you
                        when something new arrives!
                      </p>
                    </div>
                  </div>

                  <div class="card-footer text-center">
                    <router-link to="/pemberitahuan">
                      <span style="font-size: 12px" class="text-muted btn-link"
                        >Lihat Selengkapnya..</span
                      >
                    </router-link>
                  </div>
                </div>
              </div>
            </li>

            <li class="nav-item">
              <template v-if="isLoggedIn">
                <div class="dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    href="#"
                  >
                    <img
                      class="rounded-circle header-profile-user mr-1"
                      style="padding: 0px 0px 0px 0px"
                      v-bind:src="user.image.primary"
                      alt="Header Avatar"
                    />
                    <p>
                      {{
                        user.name
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (s) => s.charAt(0).toUpperCase() + s.substring(1)
                          )
                          .join(" ")
                      }}
                    </p>
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" @click="toProfile">Profile</a>

                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#changePasswordModal"
                      >Ubah Password</a
                    >
                    <a class="dropdown-item" @click="logout">
                      <i class="fas fa-sign-out-alt"></i> Logout
                    </a>
                  </div>
                </div>
              </template>
              <template v-else>
                <li class="nav-item">
                  <a class="nav-link" href="">Login</a>
                </li>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// import axios from "axios";
import { shrinkSideBar } from "/src/plugins/shrinkSideBar.js";
import { navbarToggler } from "/src/plugins/navbarToggler";
import ModalChangePassword from "../seller/modal/ModalChangePassword.vue";
import axios from "axios";

import $ from "jquery";

// function forceLogout() {
//   let userProfileUrl = "user/profile/seller";
//   axios
//     .get(`${userProfileUrl}`)
//     .then(function (response) {
//       try {
//         if (Object.keys(response.data).length === 0) {
//           document.getElementById("forceLogout").click();
//         }
//       } catch (error) {
//         ("");
//       }
//     })
//     .catch(function (response) {
//       console.error(response);
//     });
// }

export default {
  data() {
    return {
      activeTab: "informasi",
      isNotifReminder: 0,
      notifReminderParam: 0, // Variabel baru untuk parameter API
      notifications: [],
      isInitialLoad: true,
      filters: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
      notif: "notif",
    }),
    filteredNotifications() {
      console.log(this.notifications, "notif develop");

      if (this.activeTab === "informasi") {
        return this.notif.items; // Tampilkan semua notifikasi
      } else {
        return this.notif.items.filter((notif) =>
          /^<strong>.*<\/strong>/.test(notif.text)
        );
      }
    },
  },
  components: {
    ModalChangePassword,
  },
  mounted: function() {
    shrinkSideBar();
    navbarToggler();
    // forceLogout();
    console.log(this.user, "user");

    console.log(this.user.totalNotifReminder, "totalNotif");
  },

  methods: {
    updateTab(tab, reminderValue) {
      this.activeTab = tab;
      this.notifReminderParam = reminderValue; // Atur parameter API

      // Muat ulang notifikasi dengan parameter baru
      this.notifications = []; // Bersihkan notifikasi saat ini
      this.isLoading = true;

      this.infiniteHandler();
    },

    infiniteHandler($state) {
      let notifUrl = "user/notification/seller?limit=10";

      axios
        .get(notifUrl, {
          params: {
            isNotifReminder: this.notifReminderParam, // Gunakan parameter baru
            page: 1,
            filter_type: "all",
          },
        })
        .then(({ data }) => {
          $(".placeholderCard").hide();
          this.filters = data.data.filters[0].items;
          if (data.data.items.length) {
            this.notifications.push(...data.data.items);
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch((error) => {
          console.error("Error loading notifications:", error);
        })
        .finally(() => {
          this.isLoading = false; // Hentikan indikator pemuatan
        });
    },

    truncateText(text) {
      if (!text) return "";
      return text.length > 40 ? text.substring(0, 40) + "..." : text;
    },
    changePassword() {
      this.$toast.info("Masih dalam pengembangan");
    },
    toProfile() {
      this.$router.push({
        path: "/profile",
      });
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("login");
      });
    },
  },
};
</script>
